import styled, { css } from "styled-components";

export const Container = styled.div`
     padding: 1rem 0;

    ${props => (props.changeVisibleContent !== 2) && css`
        display: none;
    `}
`
